import { computed } from 'vue'

import { Language } from '@/enums/language.ts'
import i18n from '@/libs/i18n'
import type { DropdownType } from '@/types/Common.ts'

const { t } = i18n.global

export const AvailableLanguages = computed((): DropdownType[] => {
    return [
        { name: `🇸🇮 ${t('language.slovenian')}`, value: Language.SLOVENIAN, image: '🇸🇮' },
        { name: `🇬🇧 ${t('language.english')}`, value: Language.ENGLISH, image: '🇬🇧' },
        { name: `🇭🇷 ${t('language.croatian')}`, value: Language.CROATIAN, image: '🇭🇷' }
    ]
})

export const getLanguage = (value: string): DropdownType => {
    const language = AvailableLanguages.value.find(x => x.value === value)
    return language ? language : { name: '', value: -1, color: '', image: '' }
}

